
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import "../css/availabilities-rates.css";
import $$ from "Dom7";
import actions from "../js/actions.js";
import URLS from "../js/Urls.js";

var moment = require("moment");

var Calendar;
var events = [];
export default {
  data: function () {
    return {
      loginResult: actions.LoginGetResult(),
      AvailParams: actions.GetAvailabilityParams(),
      eventItems: {}
    };
  },

  beforeDestroy() {
    var self = this;
  },

  on: {
    pageInit: function (e, page) {
      var AvailParams = actions.GetAvailabilityParams();
      var loginResult = actions.LoginGetResult();

      const renderEvents = calendar => {
        var currentDate = calendar.value[0];
        var TempTotalCheckIns = 0;
        var TempTotalCheckOuts = 0;
        var TempTotalNigths = 0;
        currentDate.setHours(0, 0, 0, 0);
        var currentEvents = events?.filter(function (event) {
          return event?.date?.getTime() == currentDate?.getTime();
        });
        var eventItemstemp = [];

        if (currentEvents.length) {
          currentEvents.forEach(function (event) {
            eventItemstemp.push({
              Status: event.Status,
              color: event.color
            });
          });
        }

        self.$setState({
          eventItems: eventItemstemp
        });
      };

      $$("#CustomBack").on("click", function () {
        if (app.data.currentTab === 1) app.views.main.router.navigate("/main/");else if (app.data.currentTab === 2) app.views.main.router.navigate("/main/reservationscalendar/");else if (app.data.currentTab === 3) app.views.main.router.navigate("/main/reservations/");else if (app.data.currentTab === 4) app.views.main.router.navigate("/main/availabilities/");
      });
      var page = e.detail.page;
      var self = this;
      var app = self.$app;
      var $ = self.$; // Open room

      $$("#btnOpen").on("click", function () {
        app.dialog.confirm("Are you Sure?", "Open", function () {
          SetRCStopSales(0, AvailParams.RoomCatID);
        });
      }); // Close room

      $$("#btnClose").on("click", function () {
        app.dialog.confirm("Are you Sure?", "Close", function () {
          SetRCStopSales(1, AvailParams.RoomCatID);
        });
      });
      var initalizedates = [];
      initalizedates.push(new Date(AvailParams.FromDate));

      if (AvailParams.Todate != null) {
        initalizedates.push(new Date(AvailParams.Todate));
      }

      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      Calendar = app.calendar.create({
        containerEl: "#roomstatus-calendar-inline-container",
        rangePicker: true,
        value: initalizedates,
        weekHeader: false,
        disabled: [{
          from: new Date().minDate,
          to: yesterday
        }],
        renderToolbar: function () {
          return '<div class="toolbar calendar-custom-toolbar no-shadow calendarcustomtoolbar">' + '<div class="toolbar-inner">' + '<div class="left">' + '<a href="#" class="link icon-only"><i class="icon icon-back ' + (app.theme === "md" ? "color-black" : "") + '"></i></a>' + "</div>" + '<div class="center"></div>' + '<div class="right">' + '<a href="#" class="link icon-only"><i class="icon icon-forward ' + (app.theme === "md" ? "color-black" : "") + '"></i></a>' + "</div>" + "</div>" + "</div>";
        },
        on: {
          open: function (c) {
            var fromdate = new Date(AvailParams.FromDate);
            c.setYearMonth(fromdate.getFullYear(), fromdate.getMonth(), 0);
            c.update();
            var MyDate = c.value[0].getFullYear() + "-" + (c.value[0].getMonth() + 1) + "-" + c.value[0].getDate();
            var dateFrom = c.value[0];
            var dateTo = c.value[1] ?? null;
            var currentmonth = c.currentMonth;
            var currentyear = c.currentYear;
            var currentCalendar = new Date(currentyear, currentmonth, 1);
            var currentCalendar2 = new Date(currentyear, currentmonth, 1);
            var from = currentCalendar;
            var To = currentCalendar2;
            from.setDate(currentCalendar.getDate() - 7);
            To.setDate(currentCalendar2.getDate() + 38);
            var fromStr = moment(from).format('DD-MM-YYYY');
            var toStr = moment(To).format('DD-MM-YYYY');
            GetEventsdata(fromStr, toStr);
          },
          init: function (c) {
            renderEvents(c);
            $(".calendar-custom-toolbar .center").text(monthNames[c.currentMonth] + ", " + c.currentYear);
            $(".calendar-custom-toolbar .left .link").on("click", function () {
              c.prevMonth();
            });
            $(".calendar-custom-toolbar .right .link").on("click", function () {
              c.nextMonth();
            });
          },
          monthYearChangeStart: function (c) {
            var dateFrom = c.value[0];
            var dateTo = c.value[1] ?? null;
            $(".calendar-custom-toolbar .center").text(monthNames[c.currentMonth] + ", " + c.currentYear);
            var currentmonth = c.currentMonth;
            var currentyear = c.currentYear;
            var currentCalendar = new Date(currentyear, currentmonth, 1);
            var currentCalendar2 = new Date(currentyear, currentmonth, 1);
            var from = currentCalendar;
            var To = currentCalendar2;
            from.setDate(currentCalendar.getDate() - 7);
            To.setDate(currentCalendar2.getDate() + 38);
            var fromStr = moment(from).format('DD-MM-YYYY');
            var toStr = moment(To).format('DD-MM-YYYY');
            GetEventsdata(fromStr, toStr);
          }
        }
      });

      async function SetRCStopSales(open, RoomCategoryID) {
        var cal = Calendar.getValue();
        var fromdate = cal[0];
        var todate = cal.length > 1 ? cal[1] : fromdate;
        var fromstr = moment(fromdate).format("YYYY-MM-DD");
        var tostr = moment(todate).format("YYYY-MM-DD");
        const UserSpecificApiKey = loginResult?.PropertiesList?.find(property => property.PropertyName == loginResult?.PropertyName)?.UserSpecificApiKey;
        var obj = {
          PropertyID: loginResult?.PropertyID,
          FromDate: fromstr,
          ToDate: tostr,
          RoomCatID: RoomCategoryID,
          UserID: loginResult?.UserID,
          StopSales: open,
          UserSpecificApiKey: UserSpecificApiKey
        };
        app.preloader.show();
        await app.request.promise.post(URLS.SetRCStopSales, {
          obj
        }).then(res => {
          app.preloader.hide();

          if (res.data == '"Invalid WH Room Code"') {
            var toastBottom = app.toast.create({
              text: "We could not change availability",
              closeTimeout: 2000,
              cssClass: "toast_red"
            });
            toastBottom.open();
          } else if (res.data == '"Ok"') {
            var toastBottom = app.toast.create({
              text: "Availability changed succesfully",
              closeTimeout: 2000,
              cssClass: "toast_green"
            });
            toastBottom.open();
          }

          Getdata(Calendar.value[0], Calendar.value[1]);
        });
      }

      async function Getdata(dateFrom, dateTo, c) {
        var ResponseGetMonthlyAvailabilityData = {};
        ResponseGetMonthlyAvailabilityData = await actions.GetMonthlyAvailabilityData(dateFrom, dateTo, AvailParams.RoomCatID);
        events = [];
        ResponseGetMonthlyAvailabilityData.forEach(function (item) {
          var re = /-?\d+/;
          var m = re.exec(item.Date);
          var d = new Date(parseInt(m[0]));
          var obj = {
            Status: item.Status
          };
          events.push(obj);
        });
        Calendar.params.events = events;
        Calendar.setValue(initalizedates);
        Calendar.update();
      }

      async function GetEventsdata(dateFrom, dateTo, c) {
        var ResponseGetMonthlyAvailabilityData = {};
        var obj = {
          PropertyID: loginResult?.PropertyID,
          UserID: loginResult?.UserID,
          DateFrom: dateFrom,
          DateTo: dateTo,
          RoomCategoryID: AvailParams.RoomCatID
        };
        app.preloader.show();
        var response = await app.request.promise.postJSON(URLS.GetMonthRoomsDetails, {
          obj
        });
        app.preloader.hide();
        var events = [];
        ResponseGetMonthlyAvailabilityData = response.data;
        ResponseGetMonthlyAvailabilityData.forEach(function (item) {
          var d = moment(item.DateStr, "DD/MM/YYYY").toDate();
          var obj = {
            date: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
            color: item.Color
          };
          events.push(obj);
        });
        Calendar.params.events = events;
        Calendar.update();
      }
    },

    pageBeforeRemove() {}

  },
  id: 'c1b7f0df97',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=roomstatus><!-- Top Navbar --><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# id=CustomBack class=link><i class="icon icon-back"></i></a></div><div class=title>';
      r += Template7Helpers.t.call(ctx_1, 'availability', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><!-- Scrollable page content--><div class="page-content availabilitiespage"><div id=roomstatus-calendar-inline-container></div><div class=block><div class=row><div class=card><div class="card-content card-content-padding takis"><div class=row><div class=col-100><span><b>';
      r += c(ctx_1.loginResult?.PropertyName, ctx_1);
      r += '</b></span> <span style=float:right><b>';
      r += c(ctx_1.AvailParams.RoomCatDesc, ctx_1);
      r += '</b></span></div></div><hr><div class=row><div class=col-50 style="margin-top: 10px"><span>Room Status</span><br></div><div class=col-50 style="display: flex; justify-content: flex-end"><div><p>Open <label class=radio><input type=radio id=btnOpen name=demo-radio-inline> <i class="icon-radio open-confirm"></i></label> Close <label class=radio><input type=radio id=btnClose name=demo-radio-inline> <i class="icon-radio open-confirm"></i></label></p></div></div></div></div></div></div></div></div><div class="fab fab-center-bottom color-blue">';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginResult?.DisableReservationActions, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a href=#><i class="icon f7-icons if-not-md">add</i> <i class="icon material-icons md-only">add</i> </a>';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' <a style="pointer-events: none;opacity:0.5;"><i class="icon f7-icons if-not-md">add</i> <i class="icon material-icons md-only">add</i> </a>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class="toolbar tabbar toolbar-bottom"><div class=toolbar-inner><a href=/main/ class=tab-link data-route-tab-id=dashboard><i class=material-icons>dashboard </i><span class=tabbar-label>Dashboard</span> </a><a href=/main/reservationscalendar/ class=tab-link data-route-tab-id=reservationscalendar><i class=material-icons>date_range </i><span class=tabbar-label>';
      r += Template7Helpers.t.call(ctx_1, 'reservationsCalendar', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span> </a><a href="" class=tab-link data-route-tab-id=""><span class=tabbar-label></span> </a><a href=/main/reservations/ class=tab-link data-route-tab-id=reservations><i class=material-icons>list </i><span class=tabbar-label>Reservations</span> </a>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginResult?.DisableAvailabilities, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a href=/main/availabilities/ class=tab-link data-route-tab-id=availabilities><i class=material-icons>date_range </i><span class=tabbar-label>Availability</span> </a>';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' <a style="pointer-events: none;opacity:0.5;" class=tab-link><i class=material-icons>date_range </i><span class=tabbar-label>Availability</span> </a>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div><div class="tabs tabs-routable"><div class="tab page-content" id=dashboard></div><div class="tab page-content" id=reservations></div><div class="tab page-content" id=addbtn></div><div class="tab page-content" id=availabilities></div><div class="tab page-content" id=reservationscalendar></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};
    